---
title: Enterprise AI that cannot operate is a slide
slug: prediction-has-to-operate
type: linkedin-highlight
status: published
featured: true
summary: The interesting question is not whether a model can be trained. It is whether someone who owns the outcome can still run it on a Thursday.
sitePublishedAt: "2026-09-18"
originalPublishedAt: "2025-09-01"
lastReviewedAt: "2026-09-18"
audiences:
  - business
themes:
  - prediction-in-production
sourceUrl: https://www.linkedin.com/in/jayvanzyl/
originalAuthor: Jay van Zyl
sourceRelationship: adapted from public LinkedIn themes on enterprise AI that fails to scale; replace sourceUrl with the canonical post when filing the next highlight
rightsStatus: first-party
seoDescription: Prediction has to be something an operator can still run.
canonicalPath: /thinking/prediction-has-to-operate
---

Most “AI factories” stall between a notebook and a channel. The missing piece is rarely another model class. It is a workbench, a runtime, a response loop, and an operator who is not the data-science team.

That is why I keep drawing the same picture: Workbench → Prediction Server → Pulse Responder → response. If the last arrow is missing, you are reporting, not intervening.
